import React from "react";
import CustomButton from "../../../UIElements/CustomButton";
import { Box, Typography } from "@mui/material";

export default function FailResponseModalContent({
    onCloseModale,
    error,
}: {
    onCloseModale: Function;
    error: string,
}) {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "2rem",
                flex: "1 0 0",
            }}
        >
            <Typography
                sx={{
                    alignSelf: "stretch",
                    color: "#005499",
                    textAlign: "center",
                    fontFamily: "Roboto",
                    fontSize: "1.75rem",
                    fontQtyle: "normal",
                    fontWeight: 700,
                    lineHeight: "normal",
                }}
            >
                Nous avons rencontré un problème technique. Vous pouvez réessayer plus tard, si la même erreur s'affiche, contacter un adminstrateur.
            </Typography>
            <Typography
                sx={{
                    alignSelf: "stretch",
                    color: "black",
                    textAlign: "center",
                    fontFamily: "Roboto",
                    fontSize: "1.75rem",
                    fontQtyle: "normal",
                    fontWeight: 700,
                    lineHeight: "normal",
                }}>
                {error}
            </Typography>
            <CustomButton
                onClick={() => {
                    onCloseModale();
                }}
                label="Compris"
                customsx={{
                    width: "100%",
                }}
            />
        </Box>
    );
}
